import React from "react";

export default function Sparkles({ count = 14 }) {
  const items = Array.from({ length: count });
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {items.map((_, i) => {
        const top = Math.random() * 100;
        const left = Math.random() * 100;
        const delay = Math.random() * 4;
        const dur = 3 + Math.random() * 3;
        const size = 4 + Math.random() * 6;
        return (
          <span
            key={i}
            className="sparkle"
            style={{
              top: `${top}%`,
              left: `${left}%`,
              width: `${size}px`,
              height: `${size}px`,
              animationDelay: `${delay}s`,
              animationDuration: `${dur}s`,
            }}
          />
        );
      })}
    </div>
  );
}
